<div class="audience">
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
        <mat-icon>face</mat-icon>
        <div>
          <span>デモグラフィック</span>
        </div>

        <mat-icon class="help" matTooltip="各サービス・サイトのユーザー属性です。"
          >help_outline</mat-icon
          >
          <app-csv-download
            [id]="csvId"
            [fileName]="csvFileName"
            [csv]="csvData$ | async"
            [loading]="csvLoading$ | async"
            [artist]="selectedArtist$ | async"
          ></app-csv-download>
        </div>
      </div>

    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px grid" fxLayoutGap.lt-md="16px">
      @if (!(loading$ | async)) {
        @if (appleMusicInfo$ | async; as appleMusic) {
          @if (appleMusic.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-pie-chart
                [info]="appleMusic"
                chartName="Apple Music (性別)"
              help="上部カレンダーで期間指定された範囲のApple Musicにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの性別をグラフ化しています。"
                [options]="options"
                [dataCollections]="dataCollectAppMusic$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-pie-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>Apple Music (性別)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (spotifyInfo$ | async; as spotify) {
          @if (spotify.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-pie-chart
                [info]="spotify"
                chartName="Spotify (性別)"
              help="上部カレンダーで期間指定された範囲のSpotifyにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの性別をグラフ化しています。"
                [options]="options"
                [dataCollections]="dataCollectSpotify$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-pie-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>Spotify (性別)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (lineInfo$ | async; as line) {
          @if (line.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-pie-chart
                [info]="line"
                chartName="LINE MUSIC (性別)"
              help="上部カレンダーで期間指定された範囲のLINE MUSICにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの性別をグラフ化しています。"
                [options]="options"
                [dataCollections]="dataCollectLine$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-pie-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>LINE MUSIC (性別)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (youtubeInfo$ | async; as youtube) {
          @if (youtube.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-pie-chart
                [info]="youtube"
                chartName="YouTube (性別)"
              help="上部カレンダーで期間指定された範囲の {{
                (selectedArtist$ | async)?.nameMain
              }} 動画（Vevo、YouTube、UGC）のストリームユーザーの性別をグラフ化しています。※UGC＝1週間で日本で5回以上視聴されており、Videoの長さが1分以上10分未満の視聴データ。"
                [options]="options"
                [dataCollections]="dataCollectYoutube$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-pie-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>YouTube (性別)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (umhpInfo$ | async; as umhp) {
          @if (umhp.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-pie-chart
                [info]="umhp"
                chartName="UM ホームページ (性別)"
              help="上記カレンダーで期間指定された範囲のUMホームページにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のページ訪問者の性別をグラフ化しています。"
                [options]="options"
                [dataCollections]="dataCollectUmhp$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-pie-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>UM ホームページ (性別)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (newsletterInfo$ | async; as newsletter) {
          @if (newsletter.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-pie-chart
                [info]="newsletter"
                chartName="ニュースレター (性別)"
              help="{{ (selectedArtist$ | async)?.nameMain }} のニュースレターの購読者数です。{{
                yesterday | date: 'yyyy-MM-dd'
              }}時点の最新の値を表示しています。"
                [options]="options"
                [dataCollections]="dataCollectNewsletter$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-pie-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>ニュースレター (性別)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (enqueteInfo$ | async; as enquete) {
          @if (enquete.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-pie-chart
                [info]="enquete"
                chartName="購入者アンケート (性別)"
                help="2017年からの購入者アンケート回答ユーザーの性別をグラフ化しています。"
                [options]="options"
                [dataCollections]="dataCollectEnquete$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-pie-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>購入者アンケート (性別)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (allEmpty$ | async) {
          <div fxFlex="1 1 33.3%" fxFlex.md="50%">
            <mat-card>
              <mat-list>
                <span class="no-data">
                  該当なし
                </span>
              </mat-list>
            </mat-card>
          </div>
        }
      }
    </div>

    <div class="div_blank"></div>
    <div
      fxLayout="row wrap"
      fxLayout.lt-md="column"
      fxLayoutGap="16px grid"
      fxLayoutGap.lt-md="16px"
      class="audidece-age"
      >
      @if (!(loading$ | async)) {
        @if (appleMusicAgeInfo$ | async; as appleMusicAge) {
          @if (appleMusicAge.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-column-chart
                [info]="appleMusicAge"
                [columnNames]="ageLabels"
                chartName="Apple Music (年齢)"
              help="上部カレンダーで期間指定された範囲のApple Musicにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの年齢をグラフ化しています。"
                [options]="optionsAge"
                [dataCollections]="dataCollectAppMusic$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-column-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>Apple Music (年齢)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (spotifyAgeInfo$ | async; as spotifyAge) {
          @if (spotifyAge.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-column-chart
                [info]="spotifyAge"
                [columnNames]="ageLabels"
                chartName="Spotify (年齢)"
              help="上部カレンダーで期間指定された範囲のSpotifyにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの年齢をグラフ化しています。"
                [options]="optionsAge"
                [dataCollections]="dataCollectSpotify$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-column-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>Spotify (年齢)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (lineAgeInfo$ | async; as lineAge) {
          @if (lineAge.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-column-chart
                [info]="lineAge"
                [columnNames]="ageLabels"
                chartName="LINE MUSIC (年齢)"
              help="上部カレンダーで期間指定された範囲のLINE MUSICにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの年齢をグラフ化しています。"
                [options]="optionsAge"
                [dataCollections]="dataCollectLine$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-column-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>LINE MUSIC (年齢)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (youtubeAgeInfo$ | async; as youtubeAge) {
          @if (youtubeAge.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-column-chart
                [info]="youtubeAge"
                [columnNames]="ageLabels"
                chartName="YouTube (年齢)"
              help="上部カレンダーで期間指定された範囲の {{
                (selectedArtist$ | async)?.nameMain
              }} 動画（Vevo、YouTube、UGC）のストリームユーザーの年齢をグラフ化しています。※UGC＝1週間で日本で5回以上視聴されており、Videoの長さが1分以上10分未満の視聴データ。"
                [options]="optionsAge"
                [dataCollections]="dataCollectYoutube$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-column-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>YouTube (年齢)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (umhpAgeInfo$ | async; as umhpAge) {
          @if (umhpAge.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-column-chart
                [info]="umhpAge"
                [columnNames]="umhpAgeLabels"
                chartName="UM ホームページ (年齢)"
              help="上記カレンダーで期間指定された範囲のUMホームページにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のページ訪問者の年齢をグラフ化しています。"
                [options]="optionsAge"
                [dataCollections]="dataCollectUmhp$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-column-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>UM ホームページ (年齢)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (newsletterAgeInfo$ | async; as newsletterAge) {
          @if (newsletterAge.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-column-chart
                [info]="newsletterAge"
                [columnNames]="ageLabels"
                chartName="ニュースレター (年齢)"
              help="期間内に取得できた最新の {{
                (selectedArtist$ | async)?.nameMain
              }} ニュースレター購読者のユーザー年齢をグラフ化しています。"
                [options]="optionsAge"
                [dataCollections]="dataCollectNewsletter$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-column-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>ニュースレター (年齢)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (enqueteAgeInfo$ | async; as enqueteAge) {
          @if (enqueteAge.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-column-chart
                [info]="enqueteAge"
                [columnNames]="ageLabels"
                chartName="購入者アンケート (年齢)"
              help="2017年からの {{
                (selectedArtist$ | async)?.nameMain
              }} の購入者アンケート回答ユーザーの年齢をグラフ化しています。"
                [options]="optionsAge"
                [dataCollections]="dataCollectEnquete$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-column-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>購入者アンケート (年齢)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }
    </div>

    <div class="div_blank"></div>
    <div
      fxLayout="row wrap"
      fxLayout.lt-md="column"
      fxLayoutGap="16px grid"
      fxLayoutGap.lt-md="16px"
      class="audidece-region"
      >
      @if (!(loading$ | async)) {
        @if (spotifyRegionInfo$ | async; as spotifyRegion) {
          @if (spotifyRegion.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-geo-chart
                [info]="spotifyRegion"
                chartName="Spotify (地域)"
              help="上部カレンダーで期間指定された範囲のSpotifyにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの地域をグラフ化しています。"
                [options]="optionsRegion"
                [dataCollections]="dataCollectSpotify$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-geo-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>Spotify (地域)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (lineRegionInfo$ | async; as lineRegion) {
          @if (lineRegion.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-geo-chart
                [info]="lineRegion"
                chartName="LINE MUSIC (地域)"
              help="上部カレンダーで期間指定された範囲のLINE MUSICにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のストリームユーザーの地域をグラフ化しています。"
                [options]="optionsRegion"
                [dataCollections]="dataCollectLine$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-geo-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>LINE MUSIC (地域)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (umhpRegionInfo$ | async; as umhpRegion) {
          @if (umhpRegion.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-geo-chart
                [info]="umhpRegion"
                chartName="UM ホームページ (地域)"
              help="上記カレンダーで期間指定された範囲のUMホームページにおける {{
                (selectedArtist$ | async)?.nameMain
              }} のページ訪問者の地域をグラフ化しています。"
                [options]="optionsRegion"
                [dataCollections]="dataCollectUmhp$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-geo-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>UM ホームページ (地域)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (newsletterRegionInfo$ | async; as newsletterRegion) {
          @if (newsletterRegion.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-geo-chart
                [info]="newsletterRegion"
                chartName="ニュースレター (地域)"
              help="期間内に取得できた最新の {{
                (selectedArtist$ | async)?.nameMain
              }} ニュースレター購読者のユーザー地域をグラフ化しています。"
                [options]="optionsRegion"
                [dataCollections]="dataCollectNewsletter$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-geo-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>ニュースレター (地域)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }

      @if (!(loading$ | async)) {
        @if (enqueteRegionInfo$ | async; as enqueteRegion) {
          @if (enqueteRegion.length > 0) {
            <div fxFlex="1 1 33.3%" fxFlex.md="50%" #container>
              <app-audience-geo-chart
                [info]="enqueteRegion"
                chartName="購入者アンケート (地域)"
              help="2017年からの {{
                (selectedArtist$ | async)?.nameMain
              }} の購入者アンケート回答ユーザーの地域をグラフ化しています。"
                [options]="optionsRegion"
                [dataCollections]="dataCollectEnquete$ | async"
                [dataCollectLoading]="dataCollectLoading$ | async"
              ></app-audience-geo-chart>
            </div>
          }
        }
      } @else {
        <div fxFlex="1 1 33.3%" fxFlex.md="50%">
          <mat-card>
            <mat-list>
              <h3 mat-subheader>購入者アンケート (地域)</h3>
              <app-music-note></app-music-note>
            </mat-list>
          </mat-card>
        </div>
      }
    </div>

    <ng-template #dateFix>
      <img
        class="datafix_icon"
        matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
        src="./assets/data_collections.png"
        />
      </ng-template>

      <ng-template #dateNoFix></ng-template>
